import Calculator from "./Views/Calculator";

function App() {
  return (
    <Calculator />
  );
}

export default App;
